module.exports = __webpack_public_path__ + "img/11.69188c35.jpg";